const isDebug = () => {
  try {
    return process.env.REACT_APP_SERVER_ENV === 'development'
  } catch (e) {
    console.error(e)
  }
  return false
}

export { isDebug }
